import {Navigate, useOutlet} from "react-router-dom";
import {getToken, getRefreshToken, removeTokens} from "./AuthToken";
import {useEffect} from "react";
import {useSnackbar} from "notistack";
import {removeCondoId, removeCondoName, removeFilterDate, removeLocalUser} from "./AuthStorage";
import jwt_decode from "jwt-decode";


const RequireAuth = () => {
    const outlet = useOutlet()
    const { enqueueSnackbar } = useSnackbar()

    useEffect(function withoutCookies(){
        if (!getToken()){
            removeTokens()
            removeLocalUser()
            removeCondoId()
            removeCondoName()
            removeFilterDate()
        }

    },[])

    const token = getToken()

    if (!token) {
        return <Navigate to={'/login'} replace={true} />
    }

    try {
        const decoded = jwt_decode(token)
        if (decoded.must_change_password === true) {
            return <Navigate to={'/definir-senha'} replace={true} />
        }
    } catch (e) {
        // If token can't be decoded, let it pass - the API interceptor will handle 401 errors
    }

    // Only redirect to login if the refresh token is also expired
    const refreshToken = getRefreshToken()
    if (refreshToken) {
        try {
            const decodedRefresh = jwt_decode(refreshToken)
            if (decodedRefresh.exp && decodedRefresh.exp * 1000 < Date.now()) {
                removeTokens()
                removeLocalUser()
                removeCondoId()
                removeCondoName()
                removeFilterDate()
                return <Navigate to={'/login'} replace={true} />
            }
        } catch (e) {
            removeTokens()
            removeLocalUser()
            removeCondoId()
            removeCondoName()
            removeFilterDate()
            return <Navigate to={'/login'} replace={true} />
        }
    }

    return outlet
}

export default RequireAuth;
